import cn from "classnames";
import styles from "./Preview.module.scss";

export const MLAPreview = () => (
  <div className={cn(styles.preview, styles.previewMLA)}>
    <div className={styles.top}>
      <div className={styles.topLeft}>
        <div className={cn(styles.tag, styles.tagLeft)}>Surname</div>
        <div className={styles.tag}>Student’s Name</div>
        <div className={styles.tag}>Professor’s Name</div>
        <div className={styles.tag}>Course Title</div>
        <div className={styles.tag}>Date</div>
      </div>

      <div className={styles.title}>MLA formatting example</div>
    </div>

    <div className={styles.bottom}>
      <div className={cn(styles.tag, styles.tagTitle)}>Title of your work</div>
      <div className={cn(styles.tag, styles.tagBig)}>The contents of your essay</div>
    </div>
  </div>
);
